import "vite-dep-pre-bundle-external:/root/givingchain-test/frontend/node_modules/react-images-upload/index.css";